// This is visible to anyone. Only add non sensitive info.
export const token='adcpprdemo'
export const baseUrl='https://laurapedroni.com'
export const piioData = { appKey: 'id7exd', domain: 'https://laurapedroni.com', lazyLoading: false }
